/** Returns tabbable descendants inside a container for focus-trap logic. */
export function getFocusableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(
    container.querySelectorAll<HTMLElement>(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
    ),
  );
}

/** Focus the first tabbable element, falling back to the container shell. */
export function focusFirstFocusable(container: HTMLElement): void {
  const focusables = getFocusableElements(container);
  const first = focusables[0];
  if (first) {
    first.focus();
    return;
  }
  container.focus();
}

/** Trap Tab/Shift+Tab within focusables; returns true when the event was handled. */
export function handleFocusTrapKeyDown(event: KeyboardEvent, container: HTMLElement): boolean {
  if (event.key !== 'Tab') return false;

  const focusables = getFocusableElements(container);
  if (focusables.length === 0) {
    event.preventDefault();
    return true;
  }

  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  if (!first || !last) return false;

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
    return true;
  }

  if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
    return true;
  }

  return false;
}
